import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {ApplicableTableSettings, infoAreaBicTable, TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, { DataFetchResult, ExportRowRenderer, ListCustomFilterRenderer, ListOrderBy, ListRowRenderer } from "../../common/AbstractListView";
import periodCloseIcon from '../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../img/periodclose-12.svg';
import constants from '../../../constants';
import {Search} from "../../../filtering";
import {NavigationType, openNewPage} from '../../../util/navigationHelpers';
import { CurrencyAmountRenderer, DateRenderer, DateTimeIncludeSecRenderer, DateTimeRenderer,
  FloatRenderer, NullableCheckboxIconRenderer, TextAlignLeftRenderer, TextAlignRightRenderer, TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlus } from '@fortawesome/free-solid-svg-icons';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import ApplicationContext from '../../../ApplicationContext';
import JobListViewContext, { RightClickContext } from '../../common/JobListViewContext';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import CurrencyLabel from '../../../uiControls/CurrencyLabel';
import {getJobNameFromInvBillCrDbJobType, JobNames} from "../../../framework.core/JobNames";
import {generalInvoiceList} from "../tableSettings";
import {InvoiceListItem} from "../../../fms.data/models/InvoiceListItem";
import IfmsModal from "../../../ui/IfmsModal";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { DraftFilterRenderer, StatusNotUseFileLockedRenderer, VoidFilterRenderer } from '../../common/commonListRenderers';
import { FmsSecTask } from '../../../fms.core/constants';
import {  getFmsGlobal } from '../../../globals';
import CustomerBalanceDetails from '../../reports/AccountBalance';
import { nowDate } from '../../../dateUtils';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';
import { findSecurityTask, findSecurityTaskWithBranch, getSecBySecTask } from '../../../util';
import * as XCol from "../../../framework.core/XExportColumn";
import CheckBoxUncontrolled from '../../../ui/CheckBoxUncontrolled';
import { FmsSecCntr } from '../../../fms.core/constants/FmsSecCntr';
import { FormType, SecType } from '../../../fms.enum';
import { CurrencyAmountValue, nullableCheckBoxValue, DateTimeSecond } from '../../common/commonExportFormat';
import { DocumentType } from '../../../framework.core/DocumentType';
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import { FmsSubMenu } from '../../../constants/fmsSubMenu';
import useReportViewer from '../../../hooks/useReportViewer';
import { BalanceIconButton, DeleteIconButton, DeleteIconButton2, EditIconButton, EditIconButton2, JournalIconButton, PrintIconButton, ViewIconButton, ViewIconButton2 } from '../../../ui/IconButton';
import PrimaryButton from '../../../ui/PrimaryButton';
import { useJournal } from '../general/journal/JournalListView';
import JobSwitchingMenuContext from '../../jobSwitchingMenuContext';
import useJobMenus from '../../../hooks/useJobMenus';
import CheckBoxIcon from '../../../ui/CheckBoxIcon';
import { SearchModelBase } from '../../../fms.data/models/SearchModelBase';

function IndicatorRenderer({ data, row}:any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';

  // function onIndicatorClick() {
  //   if (jobListContext.rowExtrasId) {
  //     return; // Some row is already selected
  //   }

  //   jobListContext.setRowExtrasId(data[row.index].id);
  // }

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;


  return (
    //div className="ifms-table-default" data-tooltip="B/L Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function DraftRenderer({cell}:any) {
  // if (cell && cell.value) {
  //   return (
  //     <div data-tooltip={'Draft'} className="ifms-table-default">
  //       <span style={{color: 'green'}}>V</span>
  //     </div>
  //   );
  // }
  
  // return <div className="ifms-table-default"></div>;
   if (cell && cell.value) {
        return <div id={`${cell.column.id}-${cell.row.index}`} className="ifms-table-default" data-tooltip={'Draft'}>
          <CheckBoxIcon value={true} />
        </div>;  
      }
    
      return <div className="ifms-table-default ifms-check-box-icon-false" id={`${cell.column.id}-${cell.row.index}`}></div>;
}

function VoidRenderer({cell}:any) {
  if (cell && cell.value === 1) {
    return (
      <div data-tooltip={'Void'} className="ifms-table-default">
        <span style={{color: 'red'}}>V</span>
      </div>
    );
  }
  
  return <div className="ifms-table-default"></div>;
}

function CurrencyRenderer(value: number | null | undefined, currency: string, isLast: boolean = false) {
  return (
    <div style={{height: '100%'}}>
      <div style={{paddingTop: '0px', lineHeight: '12px', paddingRight: !isLast ? '15px' : '25px', textAlign: 'right'}}>
        <CurrencyLabel currency={currency} value={value}/>
      </div>
    </div>
  );
}

function AccountingEntityRenderer(onLinkToAccounting: any, {data, row, value}: any) {
  const entity = data[row.index];

  return <div style={{marginTop: '0px', marginLeft: '5px', textAlign: 'left'}}>
    <button className="e-btn e-small e-link" style={{margin: '0', padding: '0', lineHeight: '12px', color: '#0d7757'}}
            onClick={() => onLinkToAccounting(entity)}>{value}</button>
    
  </div>;
}


function ConfirmedRenderer({ value, row }: any) {
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();


    let secCont = appContext.securityControls ? appContext.securityControls[JobNames.GInvo] : null;
    if (!secCont) {
      secCont = [{ secCntr: FmsSecCntr.GInvGiveCredit, contName: 'cmdNew10' },
      { secCntr: FmsSecCntr.GInvCancelCredit, contName: 'cmdNew12' },
      { secCntr: FmsSecCntr.GInvConfirmed, contName: 'chkConfirmed' }

    ];

      appContext.setSecurityControls(JobNames.GInvo, secCont);
    }
  

  async function updateConfirmed(newValue: boolean) {
    await appContext.api.setInvoiceConfirmed(row.original.id, newValue);
    row.original.confirmed = newValue;
    jobListContext.updateDataRow(row.original);
  }

  function findClickedCell(element: Element): Element | null {
    for (let i = 0; i < 6; ++i) {
      if (!element) {
        break;
      }
      if (Array.from(element.classList).some(className => className.startsWith('row-'))) {
        return element;
      }
      element = element.parentNode as Element;
    }
    return null;
  }

  return (
    <div style={{ width: '100%', textAlign: 'center' }}>
      <CheckBoxUncontrolled
        key={row.original.id}
        initialValue={Boolean(value)}
        onChange={updateConfirmed}
        disabled={appContext.getControlDisableStatus(JobNames.GInvo, 'chkConfirmed', FormType.ModeEdit)}
        allowOnChange={async (e) => {
          if (!e) return false;

          e?.stopPropagation();

          const element = findClickedCell(e.currentTarget);
          if (!element) {
            await showGlobalOkDialog(<p>Cannot find hover element</p>, false, null, 'warning');
            return false;
          }

          const classes = element.classList;
          const mouseOverRowIndex = Array.from(classes).find(className => className.includes('row-'))?.match(/\d+$/)?.[0];

          if (!mouseOverRowIndex || !jobListContext.data) {
            await showGlobalOkDialog(<p>Cannot find hover data</p>, false, null, 'warning');
            return false;
          }

          const rowData = jobListContext.data[parseInt(mouseOverRowIndex)];
          if (rowData.void > 0) {
            await showGlobalOkDialog(<p>This Invoice has been voided.</p>);
            return false;
          } else if (rowData.paidAmount !== 0) {
            await showGlobalOkDialog(<p>This Invoice has been already paid.</p>);
            return false;
          } else if (rowData.draft) {
            await showGlobalOkDialog(<p>This Invoice is Draft.</p>);
            return false;
          } else {
            return true;
          }
        }} />
    </div>
  );
}


function useSelectedOperations() {
  const fmsGlobal = getFmsGlobal();
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  const context = useContext(JobSwitchingMenuContext);
  const {removeSingleJobMenuinTab} = useJobMenus();
  // const sourceUrl = `${history.location.pathname}${history.location.search}`;
  const operation = 'accounting';

  const selectedElement = jobListContext.selectedElement as InvoiceListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  async function create() {
    if (jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/${operation}/acGeneralInvoice/add`)) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    openNewPage(history, `/${operation}/acGeneralInvoice/add`, NavigationType.newPage);
  }

  async function deleteItem() {
    if (!selectedElement) {
      return;
    }

    // if (
    //   jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/${operation}/acGeneralInvoice/edit/${selectedElement.id}`) || 
    //   jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/${operation}/acGeneralInvoice/view/${selectedElement.id}`)
    // ) {
    //   await showGlobalOkDialog('Need to close Invoice first', false, null, "warning");
    //   return;
    // }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        {selectedElement.draft && <h3>Delete will remove draft data permanently.</h3>}
        <h3>Do you want to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.Invoice, { id:selectedElement.id, opAcctBlockAfterClosed: fmsGlobal?.OPAcctBlockAfterClosed??false });
      if (apiResult && apiResult.success) {
          // List에서 데이터를 Delete할 때 해당 데이터가 View/Edit 모드로 Open 되어있으면 그 탭을 Close하도록 동작
          const editUrl = `/${operation}/acGeneralInvoice/edit/${selectedElement.id}`;
          const viewUrl = `/${operation}/acGeneralInvoice/view/${selectedElement.id}`;
          if ( jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editUrl) || jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(viewUrl)) {
            context.resetForCurrentJob();
            removeSingleJobMenuinTab(jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editUrl) ? editUrl : viewUrl,'');
          }
        
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message,false,null,'warning');
      }
    }
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement?.id;
    const editUrl = `/${operation}/acGeneralInvoice/edit/${id}`;
    const viewUrl = `/${operation}/acGeneralInvoice/view/${id}`;
    
    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe(`/${operation}/acGeneralInvoice/edit`, editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement?.id;
    const editUrl = `/${operation}/acGeneralInvoice/edit/${id}`;
    const viewUrl = `/${operation}/acGeneralInvoice/view/${id}`;

    const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AcctGInvoList, selectedElement.branch);
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acGeneralInvoice/add`)) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/${operation}/acGeneralInvoice/add?copyId=${id}`, NavigationType.newPage);
  }

  async function viewPaymentHistory() {
    if (!selectedElement) {
      return;
    }

    const jobId = selectedElement.id;
    const jobName = JobNames.GInvo;
    const jobType = selectedElement.jobType

    const viewUrl = `/accounting/acPaymentHistoryView/${jobName}/${jobId}/${getJobNameFromInvBillCrDbJobType(jobType)}`;
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function switchToPayment(){
    if (!selectedElement) {
      return;
    }

    const tbName = 'T_INVOHD';
    const apiResult = await appContext.api.getPaymentIds(tbName,selectedElement.id);
    if(apiResult && apiResult.result){
      const paymentDataInfos = apiResult.result;     
      let model = new SearchModelBase();
      let link = '';

      if(paymentDataInfos.length === 0){
        await showGlobalOkDialog(<p>This G.Invoice has not been paid!</p>);
        return;
      }

      let cpayIds = paymentDataInfos.filter((item: any) => item.Type === "D").map((item: any) => item.DepoHdId).join(','); 
      let bpayIds = paymentDataInfos.filter((item: any) => item.Type === "C").map((item: any) => item.DepoHdId).join(','); 
      const cPaySec = findSecurityTask(appContext, FmsSecTask.AcctCustPayment);
      const bPaySec = findSecurityTask(appContext, FmsSecTask.AcctBillPayment);

      if(cPaySec.grantRead && cpayIds.length > 0) {
        link = '/common/joblistview/acCustomerPayment/accounting';
        model.extraWhere = `Id in (${cpayIds})`;
        jobListContext.setFilterForScreenExternally(link,'','','Payments','',false,true,model);
        openNewPage(history, link, NavigationType.newPage);
      }

      if(bPaySec.grantRead && bpayIds.length > 0) {
        link = '/common/joblistview/acBillPayment/accounting';
        model.extraWhere = `Id in (${bpayIds})`;
        jobListContext.setFilterForScreenExternally(link,'','','Payments','',false,true,model);
        openNewPage(history, link, NavigationType.newPage);
      } 
    }
  }

  return {create, deleteItem, edit, view, copy, operation, viewPaymentHistory, switchToPayment };
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteItem, edit, view, copy, switchToPayment } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  // const isDraft = jobListContext.selectedElement.draft;
  const selectedElement = jobListContext.selectedElement as InvoiceListItem;
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AcctGInvoList, selectedElement?.branch);

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Go to Pay List', shortcut: 'F7', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: true, hidden: !listSec?.grantAdd },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="gInvoice-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteItem();
        break;
      case 4:
        jobListContext.triggerTableSearch('F5');
        break;
      case 5:
        switchToPayment();
        break;
      case 6:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 7:
        copy();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

 function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  //  const jobListContext = useContext(JobListViewContext);
  //  const selectedElement = jobListContext.selectedElement as InvoiceListItem;
  //  const {switchJournal} = useJournal();
  //   const appContext = useContext(ApplicationContext);
  
  // if ((!getSecBySecTask(appContext, FmsSecTask.ListJournalBillings, SecType.Read)  && !userId.startsWith('@'))) {
  //   return null;
  // }

  // return (
  //   <JournalIconButton onClick={()=> switchJournal(JobNames.GInvo, selectedElement.id, "", null, selectedElement.invoiceToName)} useText/>
  // );
  return  null;
}




function ListCommands() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);

  const selectedElement = jobListContext.selectedElement as InvoiceListItem;

  const {deleteItem, edit, view, copy, operation, /* viewPaymentHistory */} = useSelectedOperations();

  const appContext = useContext(ApplicationContext);
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const { viewReport } = useReportViewer();
  const {switchJournal} = useJournal();
  
  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acGeneralInvoice/add`);
  }

  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AcctGInvoList, selectedElement?.branch);
  //const hasSecCp = getSecBySecTask(appContext, FmsSecTask.AcctCustPayment, SecType.Add);
  //const hasSecBp = getSecBySecTask(appContext, FmsSecTask.AcctBillPayment, SecType.Add);
  const hasSecBal = getSecBySecTask(appContext, FmsSecTask.ListBalance, SecType.Read);

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;
  const canBeAdd =  listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;
  const userId = appContext.user?.id ?? '';
  const checkSecJournal = !getSecBySecTask(appContext, FmsSecTask.ListJournalBillings, SecType.Read)  &&  !userId?.startsWith('@');

  //const disablePrint = hasSelectedRow && selectedElement.draft;

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function print(){
    if (!selectedElement) {
      return;
    }

    let puInvoice: boolean = false;
    if (appContext.suntekSettings?.company?.companyId === "AECL002209") {
      const doConfirm = await showGlobalYesNoDialog(
        <div>
          <h3>Do you want to Print?</h3>
          <p>Do you want to print P/U Invoice?</p>
        </div>
      ,false, 0, true);
      if (doConfirm) {
        puInvoice = true;
      }
    }

    if(!puInvoice && appContext.suntekSettings?.company?.country === "MEXICO" && appContext.suntekSettings?.company?.companyId === "PEOP002103"){
        // Batch Invoice
        openNewPage(history, '/accounting/batchPrint/invoice/add', NavigationType.newPage);
    }else{
      const args = await getSelectedSubMenuArgs(puInvoice ? FmsSubMenu.PuInvoice : FmsSubMenu.Invoice, JobNames.Invoice, selectedElement, appContext, null, null);
      if(args){
        viewReport(args, "", true);
      }
    }
  }

  // async function onCustomerBillAction(item: ActionButtonItem) {
  //   //const link = item.index === 0 ? `/accounting/acCustomerPayment/add/${selectedElement.invoiceTo}` : `/accounting/acBillPayment/add/${selectedElement.invoiceTo}`;
  //   let link = '';

  //   switch (item.index) {
  //     case 0:
  //       link = `/accounting/acCustomerPayment/add`;
  //       break;
  //     case 1:
  //       link = `/accounting/acBillPayment/add`;
  //       break;
  //     case 2: jobListContext.setFilterForScreenExternally('/common/joblistview/acCustomerPayment/accounting', 
  //       'invoiceNo', 'Billings', selectedElement.invoiceNo, 'updated', false, true, null );
  //       openNewPage(history, '/common/joblistview/acCustomerPayment/accounting', NavigationType.newPage);
  //       return;
  //     case 3:

  //     jobListContext.setFilterForScreenExternally('/common/joblistview/acBillPayment/accounting', 
  //       'invoiceNo', 'Billings', selectedElement.invoiceNo, 'updated', false, true, null);
  //       openNewPage(history, '/common/joblistview/acBillPayment/accounting', NavigationType.newPage);
  //       return;
  //   }
    
  //   if (jobListContext.hasOpenedScreenStartingWithUrl(link)) {
  //     await showGlobalOkDialog(<p>Operation is already in progress.</p>);
  //     return;
  //   }

  //   openNewPage(history, `${link}/${selectedElement.invoiceTo}`, NavigationType.newPage);
  // }

  // async function onHistoryAction(item: ActionButtonItem) {
  //   if (item.index === 0) {
  //     viewPaymentHistory();
  //   }

  //   if (item.index === 1) {
  //     setSelectedPopupMenuItem({ label: 'View History', popupWidth: 1200, popupComponent: <HistoryViewDetails jobId={selectedElement.id} jobType={selectedElement.jobType} jobName={JobNames.GInvo} /> })
  //   }
  // }

  async function invoiceBalance() {
    if (selectedElement.invoiceTo <= 0 && (selectedElement.invoiceToName === null || selectedElement.invoiceToName === '')) {
      await showGlobalOkDialog(<p>You didn't enter Agent.</p>,false,null,'warning');
      const focusElement = document.getElementById('generalInvoice-invoiceTo');
      if (focusElement) {
        focusElement.focus();
      }
      return;
    }
    setSelectedPopupMenuItem({
      label: 'Balance',
      popupWidth: 780,
      popupComponent:
        <CustomerBalanceDetails
          jobId={selectedElement.id}
          jobName={JobNames.GInvo}
          onPopupClose={onPopupClose}
          //toDate={invoice.postDate || ''}
          toDate={selectedElement.invoiceDate??nowDate()}
          comId={selectedElement.invoiceTo}
          comType={'C'}
          branch={''}
          subCode={''}
          customerName={selectedElement.invoiceToName}
        />
    })
  }

  return (
     <div className='ifms-common-no-vertical-separator-gap-margin'>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <UniqueLinkButton newStyle name='gInvoice-list-add-button' display="primary" link={`/${operation}/acGeneralInvoice/add`} disabled={!canBeAdd} label={''} useOnlyIcon data-tooltip='New' iconMode />
        <EditIconButton2 name='gInvoice-list-edit-button' disabled={!canBeEdit} onClick={edit} useText />
        <ViewIconButton2 name='gInvoice-list-view-button' disabled={!hasSelectedRow} onClick={view} useText />
        <DeleteIconButton2 name='gInvoice-list-delete-button' disabled={!canBeDeleted} onClick={deleteItem} useText />
      </div>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <PrintIconButton
          name='gInvoice-print-button'
          disabled={!hasSelectedRow}
          onClick={print}
          useText />
        {hasSecBal && (
          <BalanceIconButton
            name='gInvoice-balance-button'
            disabled={!hasSelectedRow}
            onClick={invoiceBalance}
            useText />
        )}
      </div>
      <div className='ifms-common-vertical-gap-8'>
       <PrimaryButton name='gInvoice-list-copy-button' disabled={!canBeCopied} onClick={copy} size={'extrasmall'}>Copy/Paste</PrimaryButton>
      {!checkSecJournal && <JournalIconButton onClick={()=> switchJournal(JobNames.GInvo, selectedElement.id, "", null, selectedElement.invoiceToName)} useText/>}
      </div>
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
        </IfmsModal>
      ) : null}
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({onFunction: onFunctionKey});
  
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as InvoiceListItem;
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AcctGInvoList, selectedElement?.branch);
  const history = useHistory();

  const {copy, create, edit, view, switchToPayment} = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "CTRL+F2") {
      if(listSec?.grantAdd)
        copy();
    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    } else if (unprocessedFkey === "F7") {
      switchToPayment();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F2', 'CTRL+F2', 'F3', 'F9', 'F11', 'F8', 'F7'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  
  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      //entityName={constants.infoAreaEntity.oceanExportMbl}
      jobName={JobNames.GInvo}
      //entityId={(jobListContext.selectedElement as OeMblListItem | null)?.id}
      jobId={(jobListContext.selectedElement as InvoiceListItem | null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
    />
  );
}

function AfterMemoLogButtonCommands() {
  // const jobListContext = useContext(JobListViewContext);
  // const selectedElement = jobListContext.selectedElement as InvoiceListItem;
  // const appContext = useContext(ApplicationContext);
  // const listSec = findSecurityTask(appContext, FmsSecTask.AcctGInvoList);
  // const [showGlobalOkDialog] = useGlobalOkDialog();
  // const history = useHistory();

  // const operation = 'accounting';

  // const hasSelectedRow = !!selectedElement;
  // const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;

  // function hasOpenedNew() {
  //   return jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acGeneralInvoice/add`);
  // }

  // async function copy() {
  //   if (!selectedElement) {
  //     return;
  //   }

  //   if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acGeneralInvoice/add`)) {
  //     await showGlobalOkDialog(<p>New operation is already in progress.</p>);
  //     return;
  //   }

  //   const id = selectedElement.id;
  //   openNewPage(history, `/${operation}/acGeneralInvoice/add?copyId=${id}`, NavigationType.newPage);
  // }

  // return (
  //   <>
  //     <PrimaryButton name='gInvoice-list-copy-button' disabled={!canBeCopied} onClick={copy} size={'extrasmall'}>Copy/Paste</PrimaryButton>
  //   </>
  // )

  return  null;
}

/**
 * Concrete implementation for Quotation List screen
 *
 * @class GeneralInvoiceListView
 * @extends {AbstractListView}
 */
class GeneralInvoiceListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const searchModel = InvoiceListItem.calculateSearchParameters(search, InvoiceListItem.MapSearchFields, ['void']);
    const apiResult = await api.getListItems(
      JobNames.GInvo,
      'InvoiceListItem',
      searchModel,
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: InvoiceListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const searchModel = InvoiceListItem.calculateSearchParameters(search, InvoiceListItem.MapSearchFields, ['void']);
    const apiResult = await api.getListItems(JobNames.GInvo, 'InvoiceListItem',
      searchModel,
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return InvoiceListItem.formatData(apiResult.entities);
  }
  

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'statusNotUseFileLocked',
        renderer: StatusNotUseFileLockedRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      // {
      //   accessor: 'void',
      //   renderer: VoidFilterRenderer,
      //   searchValueExtractor: (v:any|null|undefined) => v === 'V' ? 1 : 0,
      // },
      //{
      //  accessor: 'draft',
      //  renderer: DraftFilterRenderer,
      //  searchValueExtractor: (v:any|null|undefined) => v === 'D' ? true : false,
      //},
      {
        accessor: 'confirmed',
        renderer: undefined,
        searchValueExtractor: (v: any | null | undefined) => v.value !== undefined ? v.value : v,
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(opType: string, systemSettings: SystemSettings, suntekSettings: SuntekSettings): ListRowRenderer[] {
    const useBranch = systemSettings?.enableBranch ?? false;
    const useVat = systemSettings.useVat ?? false;
    const usebillingsTabVersion1 = suntekSettings?.company?.billingsTabVersion === 1;
    return InvoiceListItem.getExportCollection(JobNames.GInvo, useBranch, useVat, usebillingsTabVersion1).map(x => {
      const colRenderer: ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if (x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      else if (x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      } else if (x.dataIndex === "draft") {
        colRenderer.Cell = DraftRenderer;
        //colRenderer.Cell = NullableCheckboxIconRenderer;
      // } else if (x.dataIndex === "void") {
      //   colRenderer.Cell = VoidRenderer;
      }else if (x.dataIndex === "confirmed") {
        colRenderer.Cell = ConfirmedRenderer;
      } 
      else if (x.dataIndex === "amount" || x.dataIndex === "paidAmount" || x.dataIndex === "balance" || x.dataIndex === "cAmount" || x.dataIndex === "vatAmount") {
        colRenderer.Cell = props => <CurrencyAmountRenderer currencyAccessor={(x: any) => x.currency} {...props} />;
      } else if (x.dataIndex === "referenceNo" || x.dataIndex === "hblNo") {
        colRenderer.Cell = TextAlignLeftRenderer;
      } else if (x.dataIndex === 'u2Date') {
        colRenderer.Cell = DateTimeIncludeSecRenderer;
      } else if (x.dataIndex === 'overDue') {
        colRenderer.Cell = props => <FloatRenderer {...props} decimals={0} />;
      } 
      else if (x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if (x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer; 
      else if (x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) colRenderer.Cell = FloatRenderer;
      return colRenderer;
    });
  }

  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
    colRenderer.push({ accessor: 'amount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['amount']) } });
    colRenderer.push({ accessor: 'paidAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['paidAmount']) } });
    colRenderer.push({ accessor: 'balance', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['balance']) } });
    colRenderer.push({ accessor: 'cAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['cAmount']) } });
    colRenderer.push({ accessor: 'dutyAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['dutyAmount']) } });
    colRenderer.push({ accessor: 'vatAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['vatAmount']) } });
    colRenderer.push({ accessor: 'draft', changedValue: (value: any) => { return nullableCheckBoxValue(value['draft'])}});
    colRenderer.push({ accessor: 'confirmed', changedValue: (value: any) => { return nullableCheckBoxValue(value['confirmed'])}});
    colRenderer.push({ accessor: 'confirmed', changedValue: (value: any) => { return DateTimeSecond(value['confirmed'])} });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'invoiceDate',
      orderByAscending: false,
    };
  }

  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const useBranch = systemSettings?.enableBranch ?? false;
    const useVat =  systemSettings.useVat ?? false;
    const usebillingsTabVersion1 = suntekSettings?.company?.billingsTabVersion === 1;
    const tsettings =  generalInvoiceList;
    const cols = InvoiceListItem.getExportCollection(JobNames.GInvo, useBranch, useVat, usebillingsTabVersion1);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderExtras(hideLogHistory: boolean) {
    return <ListViewExtras hideLogHistory={hideLogHistory} />
  }

  getViewUrlFor(row: InvoiceListItem) {
    return row && row.id ? `/accounting/acGeneralInvoice/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'General Invoice List';
  };
  
  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.GInvo} keyProp='id' showAdjustBalance={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  commandsAfterFilterBtn():React.ReactNode{
    return <AfterMemoLogButtonCommands />
  }

  useLogHistory(): boolean {
    return true;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
}

export default GeneralInvoiceListView;
